export class DossierPeppolID {
	dossierId:number = 0;
	peppolId:string = ""
	sendOnly:boolean = false;
	hasSelfBilling:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.dossierId = data.DossierID;
		this.peppolId = data.PeppolID;
		this.sendOnly = data.SendOnly;
		this.hasSelfBilling = data.HasSelfBilling;
	}
}